import {
  // helper functions
  setCleanBasketEditState,
  hasBasketStateChanged,
} from 'actions/v3/basketEdits';
import {
  // mealServings actions
  ADD_MEAL_V3,
  REMOVE_MEAL_V3,
  ADD_SERVINGS_V3,
  REMOVE_SERVINGS_V3,
  UPDATE_MEAL_SERVINGS_V3,
  SET_BASKET_SERVINGS_V3,
  SET_EDITED_BASKET_V3,
  UNDO_BASKET_EDITS_V3,
  // mealOptions actions
  CHANGE_MEAL_OPTION_V3,
  UNDO_MEAL_OPTIONS_V3,
  // remove meals actions
  REMOVE_ALL_MEALS_V3,
} from 'lib/constants/v3Actions';
import {
  selectMealServingsForBasketEdits,
  selectMealOptionsForBasketEdits,
} from 'reducers/v3/dashboard';

const middleware = store => next => action => {
  const result = next(action);

  const actionsThatTriggerStateCheck = [
    ADD_MEAL_V3,
    REMOVE_MEAL_V3,
    ADD_SERVINGS_V3,
    REMOVE_SERVINGS_V3,
    UPDATE_MEAL_SERVINGS_V3,
    SET_BASKET_SERVINGS_V3,
    CHANGE_MEAL_OPTION_V3,
    UNDO_MEAL_OPTIONS_V3,
    REMOVE_ALL_MEALS_V3,
  ];

  const state = store.getState();
  const mealServings = selectMealServingsForBasketEdits(state);
  const selectedMealOptions = selectMealOptionsForBasketEdits(state);

  if (actionsThatTriggerStateCheck.includes(action.type)) {
    store.dispatch(hasBasketStateChanged(mealServings, selectedMealOptions));
  } else if (action.type === SET_EDITED_BASKET_V3 || action.type === UNDO_BASKET_EDITS_V3) {
    store.dispatch(setCleanBasketEditState(mealServings, selectedMealOptions));
  }

  return result;
};

export default middleware;
